import { UnreachableFunction } from 'ui/base/types';
import { Theme, ThemedStyles } from 'ui/base/theme';

import { PlanType } from 'services/accounts/types';

import baseStyles from './plan_types.module.css';

import planTypeIconImageFirewallDaylight from './plan_types_icons/firewall/light.png';
import planTypeIconImageFirewallMidnight from './plan_types_icons/firewall/dark.png';

export type PlanTypeIconStyles = {
  firewall: string;
};

export const themedPlanTypeIconClassStyles: ThemedStyles<PlanTypeIconStyles> = {
  [Theme.DAYLIGHT]: {
    firewall: baseStyles.planTypeIconClassFirewallDaylight,
  },
  [Theme.MIDNIGHT]: {
    firewall: baseStyles.planTypeIconClassFirewallMidnight,
  },
};

export const themedPlanTypeIconImageStyles: ThemedStyles<PlanTypeIconStyles> = {
  [Theme.DAYLIGHT]: {
    firewall: planTypeIconImageFirewallDaylight,
  },
  [Theme.MIDNIGHT]: {
    firewall: planTypeIconImageFirewallMidnight,
  },
};

export const getPlanTypeIcon = (styles: PlanTypeIconStyles, type: PlanType): string => {
  switch(type) {
    case PlanType.FIREWALL:
      return styles.firewall;
    default:
      return UnreachableFunction(type);
  }
};
